import type { Entities } from "../types"

export const entities: Entities = new Map([
  [
    "k3-capital",
    {
      name: "K3 Capital",
      logo: "entities/k3.svg",
      description:
        "K3 Capital provide leading institutional asset and risk management in decentralized finance.",
      url: "https://k3.capital/",
      addresses: {
        "0x3518b4c4539337369b10e0d93427e6Ba1AC44d95": "K3 Fireblocks wallet",
      },
      social: { twitter: "k3_capital" },
    },
  ],
  [
    "re7-labs",
    {
      name: "Re7 Labs",
      logo: "entities/re7labs.png",
      description:
        "Re7 Labs is the innovation arm of digital asset investment firm Re7 Capital, taking the practical experience of DeFi risk management to on-chain vaults.",
      url: "https://www.re7labs.xyz/",
      addresses: {
        "0xb1DC040D7DC52EEE3c0737633C914e849f7D9b8b":
          "Re7 Labs Euler BOB Multisig",
      },
      social: { twitter: "Re7Labs" },
    },
  ],
  [
    "tulipa-capital",
    {
      name: "Tulipa Capital",
      logo: "entities/tulipacapital.png",
      description:
        "At Tulipa Capital, we leverage cutting-edge technology and innovative financial strategies to maximize yields while implementing rigorous risk management practices.",
      url: "https://www.tulipa.capital/",
      addresses: {
        "0xF53eAeB7e6f15CBb6dB990eaf2A26702e1D986d8": "Tulipa Capital Multisig",
      },
      social: { twitter: "tulipacapital" },
    },
  ],
  [
    "mev-capital",
    {
      name: "MEV Capital",
      logo: "entities/mev-capital.svg",
      description:
        "MEV Capital is a digital asset manager that focuses on finding and extracting value from the nascent DeFi markets. The strategies are conducted following a stable asset exposure mandate supported by well-defined benchmarks. The operations mainly consist of risk curations and liquidity provisioning to a set of public protocols. These protocols are selected to reflect internal risk management rules, fit regulatory criteria, and answer investor needs. MEV Capital aims to achieve consistent returns for the investors, while operating in a highly liquid environment and battle-tested security framework.",
      url: "https://mevcapital.com/",
      addresses: {
        "0xF9686A9Eef4a771Ea7D209766A4165d59dAA6C20": "MEV Capital Multisig",
      },
      social: { twitter: "mevcapital" },
    },
  ],
])
